import React from "react";
import { styles as ui } from "stories/Admin";

/** Icons from the design that are not in the shared icon set. */
const paths = {
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
  eyeOff:
    "M3 3l18 18M10.6 5.1A10 10 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2",
  image: "M4 4h16v16H4zM4 16l5-5 4 4 3-3 4 4M15 8.5a1.5 1.5 0 1 1 0 .01",
};

interface PosterIconProps {
  name: keyof typeof paths;
  size?: number;
  strokeWidth?: number;
}

const PosterIcon: React.FC<PosterIconProps> = ({
  name,
  size = 16,
  strokeWidth = 2,
}) => (
  <svg
    className={ui.icon}
    viewBox="0 0 24 24"
    width={size}
    height={size}
    strokeWidth={strokeWidth}
    aria-hidden="true"
  >
    <path d={paths[name]} />
  </svg>
);

export default PosterIcon;
